var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"about-container"},[_c('div',{staticClass:"info"},[_vm._v("关于我功能暂时没有做哦")])])
}
var staticRenderFns = []

export { render, staticRenderFns }